import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../features/authentication/store/authStore';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Public route component that redirects authenticated users to dashboard
 * Used to wrap routes like login that should not be accessible when authenticated
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <>{children}</>;
};
